import type { UIEvent } from "react";
import type {
  FormOptionCardConfig as FormOptionCardPresentationConfig,
  FormOptionCardFieldKey,
  FormOptionCardRadioOption,
} from "app/components/FormOptionCard";
import type {
  AddOnFormValues,
  AddOnItemFormValue,
  AddOnTableKey,
  BoxDetailsFormValues,
  QuotationFormValues,
  VehicleDetailsFormValues,
  WeightAndWallFormValues,
  LoadDistributionFormValues,
} from "../../types";

export {
  DiagramDepartmentTab,
  WorkOrderDetailTab,
} from "../../types";
export type {
  AddOnDetailsState,
  AddOnFormValues,
  AddOnItemFormValue,
  AddOnTableKey,
  AddOnTableRow,
  AddOnTablesState,
  BoxDetailsFormValues,
  WeightAndWallFormValues,
  LoadDistributionFormValues,
  LoadDistributionPdfData,
  LoadDistributionPdfTableRow,
  DiagramCustomNotes,
  DiagramInfoField,
  DiagramPageData,
  DiagramSection,
  QuotationFormValues,
  VehicleDetailsFormValues,
} from "../../types";

export const WORK_ORDER_DETAIL_TABS = [
  { id: "PRICE_QUOTE", labelKey: "WORK_ORDER.DETAIL_TABS.PRICE_QUOTE" },
  { id: "VEHICLE_DETAILS", labelKey: "WORK_ORDER.DETAIL_TABS.VEHICLE_DETAILS" },
  {
    id: "CENTER_OF_GRAVITY",
    labelKey: "WORK_ORDER.DETAIL_TABS.CENTER_OF_GRAVITY",
  },
  { id: "BOX_DETAILS", labelKey: "WORK_ORDER.DETAIL_TABS.BOX_DETAILS" },
  { id: "ADDONS", labelKey: "WORK_ORDER.DETAIL_TABS.ADDONS" },
  { id: "WEIGHT_DATA", labelKey: "WORK_ORDER.DETAIL_TABS.WEIGHT_DATA" },
  {
    id: "LOAD_DISTRIBUTION",
    labelKey: "WORK_ORDER.DETAIL_TABS.LOAD_DISTRIBUTION",
  },
  { id: "PICTURES", labelKey: "WORK_ORDER.DETAIL_TABS.PICTURES" },
] as const;

export type FormFieldConfig<T extends Record<string, string | boolean>> = {
  field: keyof T;
  labelKey: string;
  type?: "text" | "number" | "select" | "textarea";
  options?: [string, string][];
  readOnly?: boolean;
  showSpinners?: boolean;
  narrow?: boolean;
  placeholderKey?: string;
  onMenuScroll?: (event: UIEvent<HTMLElement>) => void;
};

export type VehicleDetailsFieldConfig = FormFieldConfig<VehicleDetailsFormValues>;
export type BoxDetailsFieldConfig = FormFieldConfig<BoxDetailsFormValues>;
export type WeightAndWallFieldConfig = FormFieldConfig<WeightAndWallFormValues>;
export type LoadDistributionFieldConfig = FormFieldConfig<LoadDistributionFormValues>;
export type QuotationFieldConfig = FormFieldConfig<QuotationFormValues> & {
  currency?: boolean;
};

export type AddOnRadioOption = FormOptionCardRadioOption;
export type AddOnFieldKey = FormOptionCardFieldKey;

export type AddOnCardConfig = FormOptionCardPresentationConfig & {
  field: keyof AddOnFormValues;
};

export type AddOnSectionConfig = {
  titleKey: string;
  rows: AddOnCardConfig[][];
};

export type AddOnTableColumnKey =
  | "location"
  | "itemType"
  | "quantity"
  | "note"
  | "height";

export type AddOnTableConfig = {
  tableKey: AddOnTableKey;
  titleKey: string;
  modalTitleKey?: string;
  columns: AddOnTableColumnKey[];
};

export type WorkOrderPicture = {
  id: string;
  fileNameKey: string;
  dateKey: string;
  uploaderInitials: string;
};
